<template>
  <div>
    <div v-if="!$isMobile" class="main">
      <!-- PC端 -->
      <div
        :class="['toolCard', { mobildCard: $isMobile }]"
        @click="gotoHarmful(item.sort, i)"
        v-for="(item, i) in tools"
        :key="i"
      >
        <div class="bgTop">
          <span class="iconfont iconweibiaoti--"></span>
          <span :class="['sort', { mobileFontSize: $isMobile }]">{{
            item.name
          }}</span>
        </div>
        <div class="cardBody">
          <div class="toolInfo">
            <div :class="['desc', { mobileFontSize: $isMobile }]">
              {{ item.desc }}
            </div>
          </div>
        </div>
        <div :class="['viewCount', { mobileFontSize: $isMobile }]">
          <span>浏览:</span>
          <span class="iconfont iconliulan"></span>
          <span :class="['count', { mobileFontSize: $isMobile }]">
            {{ item.viewCount }}
          </span>
          <span>次</span>
        </div>
      </div>
    </div>

    <div v-else class="mobilemMainDiv">
      <div class="inline">
        <div class="searchdata">
          <el-input
            placeholder="  关键字"
            size="mini"
            @click="findAllTools()"
            v-model="search"
            @input="findAllTools"
            clearable
          >
            <i
              slot="prefix"
              @click="findAllTools()"
              class="el-input__icon el-icon-search"
            ></i>
          </el-input>
        </div>
        <div class="setup">
          <el-button size="mini" class="iconfont icon-shezhi"></el-button>
        </div>
      </div>

      <div class="mobilemMain">
        <!-- 移动端 -->

        <div
          class="appCard"
          @click="gotoHarmful(item.sort, i)"
          v-for="(item, i) in tools"
          :key="i"
        >
          <div class="nameMobile">
            <div class="name">{{ item.name }}</div>
          </div>
          <div class="descMobile">
            <div class="desc">{{ item.desc }}</div>
          </div>
          <img
            class="picture"
            v-if="item.bgImage"
            :src="`${imgDir}/${item.bgImage}`"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      tools: [],
      code: 0,
      imgDir: "",
      input: "",
      search: "",
    };
  },
  mounted() {
    this.findAllTools();
  },
  watch: {
    search() {
      delay(() => {
        this.search();
      }, 1000);
    },
  },

  filters: {
    toolsFilters: function (data) {},
  },
  methods: {
    //获取所有工具类
    findAllTools() {
      //  let res = await find({ search: this.search });

      this.$axios
        .get(this.$serviceAPI.findAllTools, { search: this.search })
        .then((res) => {
          this.tools = res.data.data;
          this.imgDir = res.data.imgDir;
        });
    },
    gotoHarmful(sort, i) {
      if (sort == 1) {
        this.$router.push({ name: "physicalExamination", params: { sort } });
      } else if (sort == 2) {
        this.$router.push({ name: "touchLimit", params: { sort } });
      } else if (sort === 3) {
        this.$router.push({ name: "noiseLevelCompute", params: { sort } });
      } else if (sort === 4) {
        this.$router.push({ name: "scanImgToExcel", params: { sort } });
      } else if (sort === 5) {
        this.$router.push({ name: "warnSignGenerate", params: { sort } });
      } else if (sort === 6) {
        this.$router.push({ name: "riskLevel", params: { sort } });
      } else if (sort === 7) {
        this.$router.push({ name: "regulations", params: { sort } });
      } else if (sort === 8) {
        this.$router.push({ name: "ppmConversion", params: { sort } });
      }
    },
  },
};
</script>

<style scoped="scoped">
@import url("../../assets/iconfont.css");
.main {
  display: flex;
  margin-top: 2.125rem;
  margin-left: 1rem;

  flex-wrap: wrap;
  /* justify-content: space-between; */
}
.mobieFlex {
  display: flex;
  justify-content: center;
  margin-top: 1.5625rem;
}
/* 每个功能框 */
.toolCard {
  margin-right: 2rem;
  transition: all ease 1s;
  width: 15rem;
  border-radius: 1.25rem;
  -moz-box-shadow: 2px -1px 13px #a3a3a3;
  -webkit-box-shadow: 2px -1px 13px #a3a3a3;
  box-shadow: 2px -1px 13px #a3a3a3;
  cursor: pointer;
  margin-bottom: 5rem;
  height: 10rem;
}
.mobildCard {
  width: 20rem;
  margin-right: 0;
}
.toolCard:hover {
  transform: scale(1.04);
  -moz-box-shadow: 2px -1px 13px #2e857f;
  -webkit-box-shadow: 2px -1px 13px #2e857f;
  box-shadow: 2px -1px 13px #2e857f;
}
/* 白框中文字 */
.toolCard .sort {
  /* 字体粗度 */
  font-weight: 700;
  font-size: 14px;
}
/* 卡片头 */
.bgTop {
  border-radius: 1.25rem;
  padding: 0 1.4rem;
  padding-top: 0.9rem;
  padding-bottom: 1rem;
  background: whitesmoke;
  color: #999;
  height: 1.875rem;
}
/* .iconweibiaoti--{
    margin-right: 0.9375rem;
  } */
/* 卡片身 */
.cardBody {
  height: 60%;
  color: white;
  padding: 1.25rem;
  background: url(../../assets/images/bg.jpg) no-repeat;
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}
/* 卡片身文字 */
/* .toolInfo {
  font-size: 13px;
  line-height: 2.25rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-top: 0.75rem;
} */
/* 浏览几次框 */
.viewCount {
  margin-left: 0.5rem;
  margin-top: 0.625rem;
  font-size: 12.5px;
  color: #999;
}
.iconliulan {
  font-size: 9px !important;
}
.mobilemMainDiv {
  margin: 0 auto;
  width: auto;
  padding: 0 0.8rem;
}
/* app中功能块 */
.mobilemMain {
  display: flex;
  /* 换行 */
  flex-wrap: wrap;
  /* justify-content: space-between; */
  margin: 0.25rem;
  justify-content: space-between;
  margin-right: -0.15rem;
  margin-top: 0.21rem;
}
.appCard {
  transition: all ease 1s;
  width: 11rem;
  height: 7.4rem;
  /* margin:0.4rem 0.2rem; */
  margin-top: 12px;
  margin-right: 0.2rem;
  margin-left: -0.2rem;
  border-radius: 0.4rem;
  position: relative;
  background: #0063e0;
  overflow: hidden;
}
/* .position{
position: absolute;
width:100%;
height: 100%;
} */
.name {
  /* width: 5.9999rem; */
  margin: 0.8rem 2.5rem 0rem 0.8rem;
  color: rgba(255, 255, 255, 0.952);
  font-weight: bold;
  font-size: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
}
.desc {
  width: 9rem;
  height: auto;
  margin: 0.18rem 0.5rem -4rem 0.8rem;
  font-size: 10px;
  color: #feffff;
  font-weight: lighter;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  overflow: hidden;
}
.descMobile {
  height: 3.68rem;

  margin-top: 0.75rem;
}
.picture {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  bottom: -1.541rem;
  right: -3.484rem;
}
.inline {
  display: inline;
}
.searchdata {
  width: 19.3rem;
  margin-left: 0.1rem;
  float: left;
  height: 2rem;
}
/* .search.input_inner{
  width: 100%;
} */
.el-input__icon {
  color: #0063df;
  font-size: 1.5rem;
  font-weight: bold;
  padding-top: 0.16rem;
  padding-left: 0.12rem;
}
.el-input {
  width: 100% !important;
}
.el-button {
  margin-left: 0.95rem;
  height: 2.44rem;
  width: 2.44rem;
  color: #0063df;
  font-size: 1.5rem;
  font-weight: bold;
  padding-top: 0.45rem;
  padding-left: 0.45rem;
  border: none;
}
.setup {
  width: -0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/subPage/indexSub.vue